import { memo, useMemo } from 'react';

import { Alert, IconWarning, Spacer } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

import type { SpacingType } from '@zillow/constellation';

import { useSelector } from '../../selectors/useSelector';

type Props = {
  contactEmail: string;
  marginTop?: typeof SpacingType;
};

const ContactEmailMismatchAlert = ({ contactEmail, marginTop = 'sm' }: Props): JSX.Element | null => {
  const { email: userEmail } = useSelector((state) => state.user);

  const { lowercaseUserEmail, lowercaseContactEmail } = useMemo(
    () => ({
      lowercaseUserEmail: userEmail?.toLowerCase(),
      lowercaseContactEmail: contactEmail?.toLowerCase(),
    }),
    [userEmail, contactEmail],
  );

  if (lowercaseUserEmail === lowercaseContactEmail) return null;

  return (
    <Spacer marginTop={marginTop}>
      <Alert
        data-testid="ContactEmailMismatchAlertContainer"
        appearance="warning"
        body={
          <Text textStyle="body-sm">This contact email differs from the one associated with your Zillow account.</Text>
        }
        // TODO: remove `icon` once `constellation` supports `aria-hidden` and `aria-describedby` from `Alert` - (phyoh)
        icon={
          <IconWarning fontColor="orange400" aria-hidden="false" aria-describedby="email-mismatch-warning">
            <title id="email-mismatch-warning">Warning</title>
          </IconWarning>
        }
      />
    </Spacer>
  );
};

export default memo(ContactEmailMismatchAlert);
